import {SearchOutlined, SoundOutlined} from '@ant-design/icons'
import {
  Button,
  Col,
  Input,
  InputNumber,
  InputRef,
  Modal,
  Row,
  Slider,
  Space,
} from 'antd'
import {ColumnType, ColumnsType} from 'antd/lib/table/interface'
import moment from 'moment'
import {FC, useEffect, useMemo, useRef, useState} from 'react'
import Highlighter from 'react-highlight-words'
import {useMutation, useQueryClient} from 'react-query'
import Swal from 'sweetalert2'
import {MenuComponent} from '../../../../../_metronic/assets/ts/components'
import {KTCardBody, initialQueryState} from '../../../../../_metronic/helpers'
import {Loading} from '../../../../../_metronic/layout/components/loading/Loading'
import {TableComponent} from '../../../../../components'
import {mapTransmissionStatus} from '../../../../../enum/TransmissionStatusEnum'
import {mapDeviceStatus} from '../../../../../enum/deviceStatus.enum'
import {useAuth} from '../../../../modules/auth/core/Auth'
import {Role} from '../../../../modules/auth/core/_models'
import {controlVolumeDeviceInfo} from '../../../MAP_New2/core/_requests'
import DeviceModal from '../components/header/DeviceModal'
import {ThietBiPagination} from '../components/pagination/ThietBiPagination'
import {useListView} from '../core/ListViewProvider'
import {useQueryRequest} from '../core/QueryRequestProvider'
import {
  useQueryResponse,
  useQueryResponseData,
  useQueryResponseLoading,
} from '../core/QueryResponseProvider'
import {Address, DeviceRequest, SpeakeritemType} from '../core/_models'
import {checkDeleteDevice, deleteDeviceInfo} from '../core/_requests'
import SpeakerModal from './SpeakerModal'

type Props = {}

const ThietBiTable: FC<Props> = () => {
  const {setItemIdForUpdate, setSelectedObject} = useListView()
  const manufactures = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data: any = useMemo(() => manufactures, [manufactures])
  const {state} = useQueryRequest()
  const {refetch} = useQueryResponse()
  const queryClient = useQueryClient()
  const {auth, setDeviceType, setLstImei, currentUser, lstImei} = useAuth()
  const DEVICE_DELETE = currentUser?.Roles.find((item: Role) => {
    return item.Value === 11
  })
  const DEVICE_CONTROL = currentUser?.Roles.find((item: Role) => {
    return item.Value === 13
  })
  const DEVICE_EDIT = currentUser?.Roles.find((item: Role) => {
    return item.Value === 11
  })
  interface DataType {
    key: string
    Id: string
    State: number
    Imei: string
    GroupName: string
    Address: Address
    LastUpdate: Date
    Info: string
    Url: string
    ManufactureName: string
    SupplierName: string
    GsmInfo: string
    Firmware: string
    FW: string
    Volumne: number
    DeviceGroupName: string
    HardWare: string
    Speakers: SpeakeritemType[]
  }
  useEffect(() => {
    MenuComponent.reinitialization()
    return () => {
      setDeviceType(undefined)
      setLstImei([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const openEditModal = (record: DataType) => {
    setItemIdForUpdate(record)
  }

  const [searchText, setSearchText] = useState('')
  const [searchedColumn] = useState('')
  const searchInput = useRef<InputRef>(null)
  type DataIndex = keyof DataType
  const [FromTime, setFromTime] = useState<string | undefined>()
  const [ToTime, setToTime] = useState<string | undefined>()
  const [isValid, setIsValid] = useState<boolean>(true)
  const [listState, setListState] = useState<any | null>()
  const {updateState} = useQueryRequest()

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isModalSpeakerOpen, setIsModalSpeakerOpen] = useState(false)
  const [, setListSpeaker] = useState<Array<any>>([{Direction: 0}])
  const [imei, setImei] = useState('')
  const [idDevice, setIdDevice] = useState('')
  const [inputValue, setInputValue] = useState(30)
  const [rowSelected, setRowSelected] = useState<DeviceRequest>()

  const handleReset = (clearFilters: () => void) => {
    clearFilters()
    setSearchText('')
  }

  const getColumnSearchProps = (dataIndex: DataIndex): ColumnType<DataType> => ({
    filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
      <div style={{padding: 8}}>
        <Input
          ref={searchInput}
          placeholder={`Tìm kiếm`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => updateFilter(dataIndex, selectedKeys[0]?.toString()?.trim() || '')}
          style={{marginBottom: 8, display: 'block'}}
        />
        <div className='`row` d-flex'>
          <div className='col-6'>
            <Button
              type='primary'
              onClick={() => updateFilter(dataIndex, selectedKeys[0]?.toString()?.trim() || '')}
              icon={<SearchOutlined />}
              size='small'
              className='w-100'
            >
              Tìm
            </Button>
          </div>
          <div className='col-6'>
            <Button
              onClick={() => {
                clearFilters && handleReset(clearFilters)
                updateFilter(dataIndex, '')
              }}
              size='small'
              className='w-100'
            >
              Làm mới
            </Button>
          </div>
        </div>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{color: filtered ? '#1890ff' : undefined}} />
    ),
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{backgroundColor: '#ffc069', padding: 0}}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  })

  const getColumnSearchTime = (dataIndex: DataIndex): ColumnType<DataType> => ({
    filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
      <div style={{padding: 8}}>
        <div className='row d-flex'>
          <div className='col-6'>
            <label className='form-label fs-6 fw-bold'>Từ ngày:</label>
            <Input
              ref={searchInput}
              style={{marginBottom: 8, display: 'block'}}
              type='date'
              placeholder='Từ ngày'
              name='FromTime'
              value={FromTime}
              onChange={(e) => {
                if (ToTime && new Date(e.target.value) > new Date(ToTime)) setIsValid(false)
                else setIsValid(true)
                setFromTime(e.target.value)
              }}
            />
            {/* {!isValidTimeFrom && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span className='text-danger' role='alert'>
                    Từ ngày không được để trống
                  </span>
                </div>
              </div>
            )} */}
          </div>
          <div className='col-6'>
            <label className='form-label fs-6 fw-bold'>Đến ngày:</label>
            <Input
              ref={searchInput}
              //onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
              style={{marginBottom: 8, display: 'block'}}
              type='date'
              placeholder='Đến ngày'
              name='ToTime'
              value={ToTime}
              onChange={(e) => {
                if (FromTime && new Date(e.target.value) < new Date(FromTime)) setIsValid(false)
                else setIsValid(true)
                setToTime(e.target.value)
              }}
            />
            {/* {!isValidTimeTo && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span className='text-danger' role='alert'>
                    Đến ngày không được để trống
                  </span>
                </div>
              </div>
            )} */}
          </div>
        </div>
        <div className='row'>
          {!isValid && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span className='text-danger' role='alert'>
                  Đến ngày phải lớn hơn Từ ngày
                </span>
              </div>
            </div>
          )}
        </div>
        <div className='row d-flex justify-content-center'>
          <div className='col-4'>
            <Button
              type='primary'
              onClick={() => {
                let tmp: any = {
                  ...((state.filter as object) || {
                    Location: {
                      CityId: '',
                      DistrictId: '',
                    },
                    Info: '',
                    Imei: '',
                    ManufactureName: '',
                    SupplierName: '',
                    Address: '',
                    DeviceGroupName: '',
                    Firmware: '',
                    Volumne: '',
                    GsmInfo: '',
                    State: null,
                    GroupIds: currentUser?.DeviceGroupIds,
                    ListImei: lstImei,
                    FromTime: null,
                    ToTime: null,
                  }),
                }
                tmp['FromTime'] = FromTime ? `${FromTime}T00:00:00Z` : null
                tmp['ToTime'] = ToTime ? `${ToTime}T23:59:59Z` : null
                updateState({
                  filter: tmp,
                  ...initialQueryState,
                })
              }}
              icon={<SearchOutlined />}
              size='small'
              className='w-100'
            >
              Tìm
            </Button>
          </div>
          <div className='col-4'>
            <Button
              onClick={() => {
                setFromTime('')
                setToTime('')
                clearFilters && handleReset(clearFilters)
                let tmp: any = {
                  ...((state.filter as object) || {
                    Location: {
                      CityId: '',
                      DistrictId: '',
                    },
                    Info: '',
                    Imei: '',
                    ManufactureName: '',
                    SupplierName: '',
                    Address: '',
                    DeviceGroupName: '',
                    Firmware: '',
                    Volumne: '',
                    GsmInfo: '',
                    State: null,
                    GroupIds: currentUser?.DeviceGroupIds,
                    ListImei: lstImei,
                    FromTime: null,
                    ToTime: null,
                  }),
                }
                tmp['FromTime'] = null
                tmp['ToTime'] = null
                updateState({
                  filter: tmp,
                  ...initialQueryState,
                })
              }}
              size='small'
              className='w-100'
            >
              Làm mới
            </Button>
          </div>
        </div>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{color: filtered ? '#1890ff' : undefined}} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100)
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{backgroundColor: '#ffc069', padding: 0}}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  })

  const getColumnSearchState = (dataIndex: DataIndex): ColumnType<DataType> => ({
    filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
      <div style={{padding: 8}}>
        <select
          style={{marginBottom: 8}}
          className='form-select form-select-solid fw-bolder p-select'
          data-kt-select2='true'
          data-placeholder='Select option'
          data-allow-clear='true'
          data-kt-user-table-filter='two-step'
          data-hide-search='true'
          name='listState'
          value={listState || 'null'}
          onChange={(e) => setListState(e.target.value)}
        >
          {/* <option value='null'>Tất cả</option>
          <option value='3'>Đang có sự cố</option>
          <option value='0'>Đang chờ phát</option>
          <option value='1'>Đang kết nối</option>
          <option value='2'>Đang phát</option>
          <option value='8'>Mất nguồn</option>
          <option value='9'>Hở mạch, Ngắn mạch</option>
          <option value='10'>Tạm dừng hoạt động</option> */}
          <option value='null'>Tất cả</option>
          {Array.from(mapDeviceStatus.values()).map((item) => (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>
        <Space>
          <Button
            type='primary'
            onClick={() => {
              let tmp: any = {...(state.filter as object)}
              if (listState === 'null') {
                tmp['State'] = null
              } else {
                tmp['State'] = parseInt(listState)
              }
              updateState({
                filter: tmp,
                ...initialQueryState,
              })
            }}
            icon={<SearchOutlined />}
            size='small'
            className='w-100'
          >
            Tìm
          </Button>
          <Button
            onClick={() => {
              clearFilters && handleReset(clearFilters)
              let tmp: any = {...(state.filter as object)}
              tmp['State'] = null
              setListState(null)
              updateState({
                filter: tmp,
                ...initialQueryState,
              })
            }}
            size='small'
            className='w-100'
          >
            Làm mới
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{color: filtered ? '#1890ff' : undefined}} />
    ),
  })

  const updateFilter = (dataIndex: any, value: any) => {
    let tmp: any = {
      ...((state.filter as object) || {
        Location: {
          CityId: '',
          DistrictId: '',
        },
        Info: '',
        Imei: '',
        ManufactureName: '',
        SupplierName: '',
        Address: '',
        DeviceGroupName: '',
        Firmware: '',
        Volumne: '',
        GsmInfo: '',
        State: null,
        GroupIds: currentUser?.DeviceGroupIds,
        ListImei: lstImei,
        FromTime: null,
        ToTime: null,
      }),
    }
    tmp[dataIndex] = value
    updateState({
      filter: tmp,
      ...initialQueryState,
    })
  }

  const [modal, setModal] = useState<{showModal: boolean; id?: string}>({
    showModal: false,
    id: undefined,
  })

  const openModal = (id: string) => {
    setModal({showModal: true, id})
  }

  const handleCancel = () => {
    setModal({showModal: false})
  }

  const columns: ColumnsType<DataType> = [
    {
      title: 'STT',
      key: 'index',
      render: (text, record, index) => index + 1 + (state.currentPage - 1) * state.pageSize,
      align: 'center',
      fixed: 'left',
      width: '5%',
    },
    {
      title: 'Tên thiết bị',
      key: 'Info',
      fixed: 'left',
      ...getColumnSearchProps('Info'),
      render: (record: DataType) => {
        return (
          <div>
            <div
              className='TextTitle'
              style={{textDecoration: 'underline', cursor: 'pointer'}}
              title={record.Info}
              onClick={() => {
                if (DEVICE_EDIT) {
                  openModal(record.Id)
                } else {
                  Swal.fire({
                    icon: 'error',
                    title: 'Bạn không có quyền chỉnh sửa thiết bị',
                    text: ' ',
                    confirmButtonText: 'Đóng lại',
                  })
                }
              }}
            >
              {record.Info}
            </div>

            {record.Url && (
              <div
                style={{
                  fontSize: '12px',
                  color: '#888',
                  marginTop: 2,
                  wordBreak: 'break-all',
                }}
                title={record.Url}
              >
                Đang phát:{' '}
                <a href={record.Url} target='_blank' rel='noopener noreferrer'>
                  {record.Url?.length > 30 ? record.Url.slice(0, 30) + '...' : record.Url}
                </a>
              </div>
            )}
          </div>
        )
      },
      width: '12%',
    },
    {
      title: 'IMEI',
      dataIndex: 'Imei',
      key: 'Imei',
      ...getColumnSearchProps('Imei'),
      width: '10%',
    },
    {
      title: 'Trạng thái phát',
      // dataIndex: 'State',
      key: 'State',
      className: 'center white-space',
      align: 'center',
      ...getColumnSearchState('State'),
      render: (record: any) => {
        return (
          <span
            style={{
              borderRadius: 40,
              padding: '3px 20px',
              color: mapTransmissionStatus.get(record.State)?.color,
              backgroundColor: mapTransmissionStatus.get(record.State)?.bgColor,
              fontWeight: 600,
              width: 'fit-content',
            }}
          >
            {mapTransmissionStatus.get(record.State)?.label}
          </span>
        )
      },
    },
    {
      title: 'Trạng thái thiết bị',
      // dataIndex: 'State',
      key: 'DeviceError',
      className: 'center white-space',
      align: 'center',
      ...getColumnSearchState('State'),
      render: (record: any) => {
        if (record.DeviceError) {
          return (
            <span
              style={{
                borderRadius: 40,
                padding: '3px 20px',
                fontWeight: 600,
                width: 'fit-content',
                color: '#f1416c',
                backgroundColor: 'rgb(255, 232, 239)',
              }}
            >
              {record.DeviceError}
            </span>
          )
        } else {
          return (
            <span
              style={{
                borderRadius: 40,
                padding: '3px 20px',
                color: mapDeviceStatus.get(record.State)?.color,
                backgroundColor: mapDeviceStatus.get(record.State)?.bgColor,
                fontWeight: 600,
                width: 'fit-content',
              }}
            >
              {mapDeviceStatus.get(record.State)?.label}{' '}
            </span>
          )
        }
      },
    },
    {
      title: 'ÂM LƯỢNG',
      key: 'Volumne',
      align: 'center',
      ...getColumnSearchProps('Volumne'),
      width: '15%',
      render: (record: DataType) => {
        return (
          <Space>
            {record.Volumne ? `${record.Volumne}%` : '0'}
            <Button
              title={'Âm lượng'}
              type='text'
              icon={<SoundOutlined />}
              onClick={() => {
                setIsModalOpen(true)
                setImei(record.Imei)
                setInputValue(record.Volumne)
              }}
            />
          </Space>
        )
      },
    },
    {
      title: 'Loa',
      dataIndex: 'Speaker',
      key: 'Speaker',
      // ...getColumnSearchProps('Speaker'),
      width: '5%',
      render: (_, record) => {
        return (
          <Space>
            <img
              width={'35px'}
              id={'Speaker'}
              src={'/media/img/speaker.png'}
              alt='Speaker'
              onClick={(e) => {
                setIsModalSpeakerOpen(true)
                setListSpeaker(record.Speakers ?? [{Direction: 0}])
                setIdDevice(record.Id)
                setRowSelected(record)
              }}
            />
          </Space>
        )
      },
    },
    {
      title: 'ĐỊA BÀN PHÁT',
      dataIndex: 'GroupName',
      key: 'GroupName',
      ...getColumnSearchProps('DeviceGroupName'),
      width: 200,
    },
    {
      title: 'NHIỆT ĐỘ',
      dataIndex: 'TempAir',
      key: 'TempAir',
      // ...getColumnSearchProps('TempAir'),
      // render: (Address: Address) =>
      //   `${Address.WardName} ${Address.WardName ? ', ' : ''} ` +
      //   `${Address.DistrictName}, ${Address.CityName}`,
      // width: '10%',
    },
    {
      title: 'KẾT NỐI MẠNG',
      dataIndex: 'GsmInfo',
      ...getColumnSearchProps('GsmInfo'),
      key: 'GsmInfo',
      width: '7%',
    },
    {
      title: 'Quá hạn',
      dataIndex: 'ExpiredDay',
      key: 'ExpiredDay',
      render: (ExpiredDay: number) => {
        // const today = new Date()
        // today.setDate(today.getDate() + ExpiretionSoonDay) // Cộng thêm 3 ngày
        return (
          <p
            className='center m-0'
            style={{
              color: ExpiredDay > 0 ? 'red' : 'black', // Màu đỏ khi > 0, mặc định là đen
              fontWeight: ExpiredDay > 0 ? 'bold' : 'normal', // Bôi đậm khi > 0
            }}
          >
            {ExpiredDay} Ngày
          </p>
        )
      },
    },
    {
      title: 'Ngày hết hạn',
      dataIndex: 'WarrantyTime',
      key: 'WarrantyTime',
      render: (WarrantyTime) => {
        // const today = new Date()
        // today.setDate(today.getDate() + ExpiretionSoonDay) // Cộng thêm 3 ngày
        return (
          <p className='center m-0'>
            {WarrantyTime ? moment(WarrantyTime).format('DD/MM/YYYY') : ''}
          </p>
        )
      },
    },
    {
      title: 'CẬP NHẬT',
      dataIndex: 'LastUpdate',
      key: 'LastUpdate',
      ...getColumnSearchTime('LastUpdate'),
      render: (LastUpdate) => {
        return <p className='center m-0'>{moment(LastUpdate).format('DD/MM/YYYY HH:mm')}</p>
      },
      width: '10%',
    },
    {
      title: 'Nhà thầu',
      dataIndex: 'ManufactureName',
      key: 'ManufactureName',
      ...getColumnSearchProps('ManufactureName'),
      render: (ManufactureName: string) => {
        return <span title={ManufactureName}>{ManufactureName}</span>
      },
      width: '10%',
    },
    {
      title: 'Hãng sản xuất',
      dataIndex: 'SupplierName ',
      key: 'SupplierName ',
      ...getColumnSearchProps('SupplierName'),
      render: (SupplierName: string) => {
        return <span title={SupplierName}>{SupplierName}</span>
      },
      width: '10%',
    },
    {
      title: 'Cấu hình',
      dataIndex: 'Configuration',
      key: 'Configuration',
      width: '5%',
    },
    {
      title: 'Phần mềm',
      dataIndex: 'Firmware',
      key: 'Firmware',
      ...getColumnSearchProps('Firmware'),
      width: '5%',
    },
    {
      title: 'Phần cứng',
      dataIndex: 'HardWare',
      key: 'HardWare',
      ...getColumnSearchProps('HardWare'),
      width: '5%',
    },
    {
      title: 'HÀNH ĐỘNG',
      key: 'Action',
      align: 'center',
      fixed: 'right',
      width: '15%',
      render: (_, record) => (
        <Space size='middle'>
          <button
            title='Chi tiết'
            className='bi bi-info-circle fs-1'
            onClick={() => {
              openEditModal(record)
            }}
            style={{
              cursor: 'pointer',
              padding: '5px 7px',
              color: '#1E2EC0',
              background: '#E0F2FF',
              borderRadius: '5px',
            }}
          ></button>
          {DEVICE_CONTROL && (
            <button
              title='Gửi lệnh'
              className='bi bi-gear-fill fs-1'
              onClick={() => {
                setSelectedObject(record)
              }}
              style={{
                cursor: 'pointer',
                padding: '5px 7px',
                color: '#1E2EC0',
                background: '#E0F2FF',
                borderRadius: '5px',
              }}
            ></button>
          )}
          {DEVICE_DELETE && (
            <button
              title='Xóa'
              className='bi bi-trash text-danger fs-1'
              onClick={() => {
                FCheckDelete(record)
              }}
              style={{
                cursor: 'pointer',
                padding: '5px 7px',
                background: '#FFE8EF',
                borderRadius: '5px',
              }}
            ></button>
          )}
        </Space>
      ),
    },
  ]

  const [visibleColumns, setVisibleColumns] = useState<string[]>(() => {
    const saved = localStorage.getItem('tableColumns')
    if (saved) return JSON.parse(saved)

    return columns.map((col) => col.key as string)
  })

  const filteredColumns = columns.filter((col) => visibleColumns.includes(col.key as string))

  useEffect(() => {
    localStorage.setItem('tableColumns', JSON.stringify(visibleColumns))
  }, [visibleColumns])

  useEffect(() => {
    const syncVisibleColumns = () => {
      const saved = localStorage.getItem('tableColumns')
      if (saved) {
        try {
          const parsed = JSON.parse(saved)
          if (Array.isArray(parsed)) setVisibleColumns(parsed)
        } catch (error) {
          console.error('Failed to parse tableColumns from localStorage', error)
        }
      }
    }

    syncVisibleColumns()
    window.addEventListener('thietbiTableColumnsChanged', syncVisibleColumns)
    return () => window.removeEventListener('thietbiTableColumnsChanged', syncVisibleColumns)
  }, [])

  const FCheckDelete = (record: DataType) => {
    CheckdeleteItem.mutateAsync(record)
  }

  const CheckdeleteItem = useMutation((record: DataType) =>
    checkDeleteDevice(auth?.configs, record.Id, (id: any, message: any) => {
      Swal.fire({
        title: message,
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: 'Quay lại',
        confirmButtonText: 'Xác nhận',
        confirmButtonColor: 'red',
        width: 500,
        reverseButtons: true,
      }).then(async function (result) {
        if (result.value) {
          await deleteItem.mutateAsync(id)
        }
      })
    })
  )

  const handleCloseSpeaker = () => {
    setIsModalSpeakerOpen(false)
  }

  const deleteItem = useMutation((id: any) => deleteDeviceInfo(auth?.configs, id), {
    // 💡 response of the mutation is passed to onSuccess
    onSuccess: () => {
      // ✅ update detail view directly
      queryClient.invalidateQueries('delete-deviceInfo')
      Swal.fire({
        icon: 'success',
        title: 'Xóa thành công',
        text: ' ',
        showConfirmButton: false,
        timer: 1500,
      })
      cancel(true)
    },
    onError: (error: any) => {
      Swal.fire({
        icon: 'error',
        title: 'Xóa thất bại',
        text: error.response.data,
        confirmButtonText: 'Đóng lại',
      })
    },
  })

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
  }

  interface VolumeInfo {
    Imei: string
    Volume: number
  }
  const handleOk = () => {
    const payload: VolumeInfo = {
      Imei: imei,
      Volume: inputValue,
    }

    try {
      controlVolumeDeviceInfo(
        auth?.configs,
        payload.Imei || '',
        payload.Volume,
        (res: any) => {
          Swal.fire({
            icon: 'success',
            title: 'Cập nhật thông tin thành công',
            text: ' ',
            showConfirmButton: false,
            timer: 1500,
          }).then((_) => {
            refetch()
          })
          // cancel()
        },
        (message: any) => {
          Swal.fire({
            icon: 'error',
            title: 'Cập nhật thông tin thất bại',
            text: ' ',
            confirmButtonText: 'Đóng lại',
            confirmButtonColor: '#009ef7',
          })
        }
      )
    } catch (ex) {
      console.error(ex)
    } finally {
      refetch()
      setIsModalOpen(false)
    }
  }
  const handleCancelVolumne = () => {
    setIsModalOpen(false)
  }
  const onChange = (newValue: any) => {
    setInputValue(newValue)
  }

  if (
    manufactures &&
    manufactures.length > 0 &&
    ('Content' in manufactures[0] || 'MediaContent' in manufactures[0])
  )
    return null
  return (
    <KTCardBody className='py-4'>
      {/* <Dropdown menu={{items}} trigger={['click']}>
        <Button>Hiển thị cột</Button>
      </Dropdown> */}
      <TableComponent columns={filteredColumns} dataSource={data} />
      <ThietBiPagination />
      {isLoading && <Loading />}
      {modal.showModal && (
        <DeviceModal
          handleCancel={handleCancel}
          isModalOpen={modal.showModal}
          id={modal.id}
          isElectronicBoard={false}
        />
      )}
      <Modal
        className='nguoi-dung-body'
        title='Thay đổi âm lượng'
        open={isModalOpen}
        onOk={handleOk}
        okText='Đồng ý'
        cancelText='Hủy'
        onCancel={handleCancelVolumne}
      >
        <Row className='al-center'>
          <Col span={20}>
            <Slider
              min={0}
              max={100}
              onChange={onChange}
              value={inputValue || 0}
              // tooltip={{open: true}}
            />
          </Col>
          <Col span={4}>
            <InputNumber min={0} max={100} value={inputValue || 0} onChange={onChange} />
          </Col>
        </Row>
      </Modal>
      <SpeakerModal
        isModalSpeakerOpen={isModalSpeakerOpen}
        handleCancel={handleCloseSpeaker}
        rowSelected={rowSelected}
        idDevice={idDevice}
      ></SpeakerModal>
    </KTCardBody>
  )
}

export {ThietBiTable}
